module.exports = __webpack_public_path__ + "static/logo-9f4ba7b4504c58e51ea17f7261e115c1.png";